"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var UiStateController_1 = require("../../../../../shared/UiStateController");
var routes_1 = require("../../../../shared/includes/routes");
var EventBindingsList_1 = require("./component/EventBindingsList");
var EventBindingEditor_1 = require("./component/EventBindingEditor");
var EventBindingBonusesList_1 = require("./component/EventBindingBonusesList");
var EventBindingBonusEditor_1 = require("./component/EventBindingBonusEditor");
var EventBindingOnDepositCfgEditor_1 = require("./component/event_config/on_deposit/EventBindingOnDepositCfgEditor");
var EventBindingOnLevelCfgEditor_1 = require("./component/event_config/on_level/EventBindingOnLevelCfgEditor");
var EventBindingOnCashBackCfgEditor_1 = require("./component/event_config/on_cashback/EventBindingOnCashBackCfgEditor");
var EventBindingDescriptionsList_1 = require("./component/EventBindingDescriptionsList");
var EventBindingDescriptionEditor_1 = require("./component/EventBindingDescriptionEditor");
var EventBindingOnLoginCfgEditor_1 = require("./component/event_config/on_login/EventBindingOnLoginCfgEditor");
var PEventBindingsList = /** @class */ (function (_super) {
    __extends(PEventBindingsList, _super);
    function PEventBindingsList(props) {
        var _this = _super.call(this, props) || this;
        _this.ET_TIMER = 1;
        _this.ET_DEPOSIT = 4;
        _this.ET_LEVEL = 5;
        _this.ET_LOGIN = 7;
        return _this;
    }
    PEventBindingsList.prototype.componentWillMount = function () {
        var _this = this;
        this.SID_AL = this.props.listAppLangs.Subscribe("*", function (id, data) {
            _this.setState({ avail_langs: data.data });
        });
        this.SID_AB = this.props.listBrands.Subscribe("*", function (id, data) {
            _this.setState({ avail_brands: data.data });
        });
        this.SID_STATE = this.props.state.Subscribe("*", function (id, data) {
            _this.setState({
                brands_list: data.brands_list,
                all_brands: data.all_brands,
                page_size: data.tablePageSize
            });
        });
        this.setState({
            edit_mode: "LIST",
            record_event: null,
            record_bonus: null,
            record_description: null,
            page_num: 1,
            page_size: this.props.state.getTablePageSize(),
            brands_list: this.props.state.getBrandsList(),
            all_brands: this.props.state.getIsAllBrands(),
            avail_brands: [],
            avail_langs: []
        }, function () {
            _this.props.listBrands.LoadData();
            _this.props.listAppLangs.LoadData();
        });
    };
    PEventBindingsList.prototype.componentWillUnmount = function () {
        this.props.listBrands.UnSubscribe(this.SID_AB);
        this.props.listAppLangs.UnSubscribe(this.SID_AL);
        this.props.state.UnSubscribe(this.SID_STATE);
    };
    PEventBindingsList.prototype.onNewEventClick = function () {
        this.setState({ edit_mode: "NEW", record_event: null });
    };
    PEventBindingsList.prototype.onNewEventBonusClick = function () {
        this.setState({ edit_mode: "BONUS-NEW", record_bonus: null });
    };
    PEventBindingsList.prototype.onNewEventDescriptionClick = function () {
        this.setState({ edit_mode: "DESCRIPTION-NEW", record_bonus: null });
    };
    PEventBindingsList.prototype.onEditEventClick = function (item) {
        this.setState({ edit_mode: "EDIT", record_event: item });
    };
    PEventBindingsList.prototype.onConfigEventClick = function (item) {
        this.setState({ edit_mode: "CONFIG", record_event: item });
    };
    PEventBindingsList.prototype.onEditEventBonusClick = function (item) {
        this.setState({ edit_mode: "BONUS-EDIT", record_bonus: item });
    };
    PEventBindingsList.prototype.onEditEventDescriptionClick = function (item) {
        this.setState({ edit_mode: "DESCRIPTION-EDIT", record_description: item });
    };
    PEventBindingsList.prototype.onEventBonusesListClick = function (item) {
        this.setState({ edit_mode: "BONUS-LIST", record_event: item });
    };
    PEventBindingsList.prototype.onEventDescriptionsListClick = function (item) {
        this.setState({ edit_mode: "DESCRIPTION-LIST", record_event: item });
    };
    PEventBindingsList.prototype.onGoBackToEventsListClick = function () {
        this.setState({ edit_mode: "LIST", record_event: null });
    };
    PEventBindingsList.prototype.onGoBackToEventBonusesListClick = function () {
        this.setState({ edit_mode: "BONUS-LIST", record_bonus: null });
    };
    PEventBindingsList.prototype.onGoBackToEventDescriptionsListClick = function () {
        this.setState({ edit_mode: "DESCRIPTION-LIST", record_description: null });
    };
    PEventBindingsList.prototype.onPageConfigChange = function (PageNum, PageSize) {
        var _this = this;
        this.setState({ page_num: PageNum }, function () {
            _this.props.state.setTablePageSize(PageSize, true);
        });
    };
    PEventBindingsList.prototype.onBrandFilterChanged = function (allBrands, BrandId, Action) {
        if (Action === "checkbox") {
            this.props.state.setAllBrands(allBrands, true);
        }
        if (Action === "add") {
            this.props.state.addBrand(BrandId, true);
        }
        if (Action === "remove") {
            this.props.state.delBrand(BrandId, true);
        }
    };
    PEventBindingsList.prototype.getRenderObject = function () {
        if (this.state.edit_mode === "NEW") {
            return (React.createElement(EventBindingEditor_1.default, { data: this.props.data, state: this.props.state, record: null, onGoBack: this.onGoBackToEventsListClick.bind(this), listBrands: this.props.listBrands, listAppCurrency: this.props.listAppCurrency, listBonusEvents: this.props.listBonusEvents, listPlayerLevels: this.props.ListPlayerLevels }));
        }
        if (this.state.edit_mode === "EDIT") {
            return (React.createElement(EventBindingEditor_1.default, { data: this.props.data, state: this.props.state, record: this.state.record_event, onGoBack: this.onGoBackToEventsListClick.bind(this), listBrands: this.props.listBrands, listAppCurrency: this.props.listAppCurrency, listBonusEvents: this.props.listBonusEvents, listPlayerLevels: this.props.ListPlayerLevels }));
        }
        if (this.state.edit_mode === "LIST") {
            return (React.createElement(EventBindingsList_1.default, { data: this.props.data, state: this.props.state, onNewClick: this.onNewEventClick.bind(this), onEditClick: this.onEditEventClick.bind(this), onConfigClick: this.onConfigEventClick.bind(this), onPageConfigChanged: this.onPageConfigChange.bind(this), pageNum: this.state.page_num, pageSize: this.state.page_size, brandsList: this.state.brands_list, allBrands: this.state.all_brands, availBrands: this.state.avail_brands, onBrandFilterChanged: this.onBrandFilterChanged.bind(this), onListBonusesClick: this.onEventBonusesListClick.bind(this), onListDescriptionsClick: this.onEventDescriptionsListClick.bind(this) }));
        }
        if (this.state.edit_mode === "BONUS-LIST") {
            return (React.createElement(EventBindingBonusesList_1.default, { data: this.props.listBonusEventBonuses, record: this.state.record_event, state: this.props.state, onNewClick: this.onNewEventBonusClick.bind(this), onEditClick: this.onEditEventBonusClick.bind(this), onGoBackClick: this.onGoBackToEventsListClick.bind(this), listBonusTemplates: this.props.listBonusTemplates }));
        }
        if (this.state.edit_mode === "BONUS-NEW") {
            return (React.createElement(EventBindingBonusEditor_1.default, { data: this.props.listBonusEventBonuses, rootRecord: this.state.record_event, record: this.state.record_bonus, state: this.props.state, listBonusTemplates: this.props.listBonusTemplates, onGoBack: this.onGoBackToEventBonusesListClick.bind(this) }));
        }
        if (this.state.edit_mode === "BONUS-EDIT") {
            return (React.createElement(EventBindingBonusEditor_1.default, { data: this.props.listBonusEventBonuses, rootRecord: this.state.record_event, record: this.state.record_bonus, state: this.props.state, listBonusTemplates: this.props.listBonusTemplates, onGoBack: this.onGoBackToEventBonusesListClick.bind(this) }));
        }
        if (this.state.edit_mode === "DESCRIPTION-LIST") {
            return (React.createElement(EventBindingDescriptionsList_1.default, { data: this.props.listBonusEventDescriptions, record: this.state.record_event, state: this.props.state, onNewClick: this.onNewEventDescriptionClick.bind(this), onEditClick: this.onEditEventDescriptionClick.bind(this), onGoBackClick: this.onGoBackToEventsListClick.bind(this) }));
        }
        if (this.state.edit_mode === "DESCRIPTION-EDIT") {
            return (React.createElement(EventBindingDescriptionEditor_1.default, { data: this.props.listBonusEventDescriptions, rootRecord: this.state.record_event, record: this.state.record_description, state: this.props.state, languagesList: this.state.avail_langs, onGoBack: this.onGoBackToEventDescriptionsListClick.bind(this), dialogSelectImage: this.props.dialogSelectImage }));
        }
        if (this.state.edit_mode === "DESCRIPTION-NEW") {
            return (React.createElement(EventBindingDescriptionEditor_1.default, { data: this.props.listBonusEventDescriptions, rootRecord: this.state.record_event, record: null, state: this.props.state, languagesList: this.state.avail_langs, onGoBack: this.onGoBackToEventDescriptionsListClick.bind(this), dialogSelectImage: this.props.dialogSelectImage }));
        }
        if (this.state.edit_mode == "CONFIG") {
            if (this.state.record_event.event_type_code == this.ET_DEPOSIT) {
                return (React.createElement(EventBindingOnDepositCfgEditor_1.default, { state: this.props.state, data: this.props.EvtBindingOnDepositCfg, record: this.state.record_event, onGoBack: this.onGoBackToEventsListClick.bind(this) }));
            }
            if (this.state.record_event.event_type_code == this.ET_LEVEL) {
                return (React.createElement(EventBindingOnLevelCfgEditor_1.default, { state: this.props.state, data: this.props.EvtBindingOnLevelCfg, record: this.state.record_event, onGoBack: this.onGoBackToEventsListClick.bind(this) }));
            }
            if (this.state.record_event.event_type_code == this.ET_LOGIN) {
                return (React.createElement(EventBindingOnLoginCfgEditor_1.default, { state: this.props.state, data: this.props.EvtBindingOnLoginCfg, record: this.state.record_event, onGoBack: this.onGoBackToEventsListClick.bind(this) }));
            }
            if (this.state.record_event.event_type_code == this.ET_TIMER) {
                return (React.createElement(EventBindingOnCashBackCfgEditor_1.default, { state: this.props.state, data: this.props.EvtBindingOnTimerCfg, record: this.state.record_event, onGoBack: this.onGoBackToEventsListClick.bind(this) }));
            }
        }
        throw "No available render for active edit mode -> " + this.state.edit_mode;
    };
    PEventBindingsList.prototype.render = function () {
        return this.getRenderObject();
    };
    PEventBindingsList.getPageDescription = function (state) {
        return {
            icon: "traffic-light",
            iconKind: "normal",
            itemId: "item-" + routes_1.routes.page_gift_event_bindings + "-id",
            itemTitle: "События",
            route: routes_1.routes.page_gift_event_bindings,
            docType: UiStateController_1.UIDocumentType.udtRegularPage
        };
    };
    return PEventBindingsList;
}(React.Component));
exports.default = PEventBindingsList;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/gift_events_bindings/ui/PEventBindingsList.tsx
// module id = 1976
// module chunks = 0